export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrayDown"] = 2] = "ArrayDown";
    IconSymbol[IconSymbol["AudioBus"] = 3] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 4] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 5] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 6] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 7] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 8] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 9] = "Book";
    IconSymbol[IconSymbol["Box"] = 10] = "Box";
    IconSymbol[IconSymbol["Browse"] = 11] = "Browse";
    IconSymbol[IconSymbol["Bug"] = 12] = "Bug";
    IconSymbol[IconSymbol["ChatEmpty"] = 13] = "ChatEmpty";
    IconSymbol[IconSymbol["ChatMessage"] = 14] = "ChatMessage";
    IconSymbol[IconSymbol["Copy"] = 15] = "Copy";
    IconSymbol[IconSymbol["Maximizer"] = 16] = "Maximizer";
    IconSymbol[IconSymbol["Fold"] = 17] = "Fold";
    IconSymbol[IconSymbol["Charts"] = 18] = "Charts";
    IconSymbol[IconSymbol["Checkbox"] = 19] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 20] = "Clips";
    IconSymbol[IconSymbol["Close"] = 21] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 22] = "CloudFolder";
    IconSymbol[IconSymbol["Code"] = 23] = "Code";
    IconSymbol[IconSymbol["CollapseDown"] = 24] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 25] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 26] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 27] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 28] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 29] = "Curve";
    IconSymbol[IconSymbol["Dattorro"] = 30] = "Dattorro";
    IconSymbol[IconSymbol["Delete"] = 31] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 32] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 33] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 34] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 35] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 36] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 37] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 38] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 39] = "DrumSet";
    IconSymbol[IconSymbol["Tidal"] = 40] = "Tidal";
    IconSymbol[IconSymbol["Duration"] = 41] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 42] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 43] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 44] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 45] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 46] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 47] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 48] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 49] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 50] = "FileList";
    IconSymbol[IconSymbol["Film"] = 51] = "Film";
    IconSymbol[IconSymbol["Flask"] = 52] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 53] = "Focus";
    IconSymbol[IconSymbol["Gate"] = 54] = "Gate";
    IconSymbol[IconSymbol["Generator"] = 55] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 56] = "GoogleDrive";
    IconSymbol[IconSymbol["Groove"] = 57] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 58] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 59] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 60] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 61] = "Heart";
    IconSymbol[IconSymbol["Help"] = 62] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 63] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 64] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 65] = "Insert";
    IconSymbol[IconSymbol["Invert"] = 66] = "Invert";
    IconSymbol[IconSymbol["Info"] = 67] = "Info";
    IconSymbol[IconSymbol["Lock"] = 68] = "Lock";
    IconSymbol[IconSymbol["Loop"] = 69] = "Loop";
    IconSymbol[IconSymbol["LoopEnd"] = 70] = "LoopEnd";
    IconSymbol[IconSymbol["LoopStart"] = 71] = "LoopStart";
    IconSymbol[IconSymbol["LowPass"] = 72] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 73] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 74] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 75] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 76] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 77] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 78] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 79] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 80] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 81] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 82] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 83] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 84] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 85] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 86] = "NanoWave";
    IconSymbol[IconSymbol["NeuralAmp"] = 87] = "NeuralAmp";
    IconSymbol[IconSymbol["New"] = 88] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 89] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 90] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 91] = "NotePad";
    IconSymbol[IconSymbol["OpenDAW"] = 92] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 93] = "Panel";
    IconSymbol[IconSymbol["Paste"] = 94] = "Paste";
    IconSymbol[IconSymbol["Peak"] = 95] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 96] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 97] = "Piano";
    IconSymbol[IconSymbol["Play"] = 98] = "Play";
    IconSymbol[IconSymbol["Playfield"] = 99] = "Playfield";
    IconSymbol[IconSymbol["PlayOnce"] = 100] = "PlayOnce";
    IconSymbol[IconSymbol["PlayRepeat"] = 101] = "PlayRepeat";
    IconSymbol[IconSymbol["PlayAlternate"] = 102] = "PlayAlternate";
    IconSymbol[IconSymbol["Pointer"] = 103] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 104] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 105] = "Primary";
    IconSymbol[IconSymbol["Random"] = 106] = "Random";
    IconSymbol[IconSymbol["Record"] = 107] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 108] = "Rectangle";
    IconSymbol[IconSymbol["Redo"] = 109] = "Redo";
    IconSymbol[IconSymbol["Region"] = 110] = "Region";
    IconSymbol[IconSymbol["Robot"] = 111] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 112] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 113] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 114] = "Run";
    IconSymbol[IconSymbol["Sawtooth"] = 115] = "Sawtooth";
    IconSymbol[IconSymbol["Saxophone"] = 116] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 117] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 118] = "Search";
    IconSymbol[IconSymbol["Shadertoy"] = 119] = "Shadertoy";
    IconSymbol[IconSymbol["Shutdown"] = 120] = "Shutdown";
    IconSymbol[IconSymbol["Sine"] = 121] = "Sine";
    IconSymbol[IconSymbol["Solo"] = 122] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 123] = "SoundFont";
    IconSymbol[IconSymbol["Speaker"] = 124] = "Speaker";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 125] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Square"] = 126] = "Square";
    IconSymbol[IconSymbol["Stack"] = 127] = "Stack";
    IconSymbol[IconSymbol["Start"] = 128] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 129] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 130] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 131] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 132] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 133] = "Swap";
    IconSymbol[IconSymbol["System"] = 134] = "System";
    IconSymbol[IconSymbol["Table"] = 135] = "Table";
    IconSymbol[IconSymbol["Tape"] = 136] = "Tape";
    IconSymbol[IconSymbol["TapeReel"] = 137] = "TapeReel";
    IconSymbol[IconSymbol["Time"] = 138] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 139] = "Timeline";
    IconSymbol[IconSymbol["Tone3000"] = 140] = "Tone3000";
    IconSymbol[IconSymbol["Tool"] = 141] = "Tool";
    IconSymbol[IconSymbol["Triangle"] = 142] = "Triangle";
    IconSymbol[IconSymbol["Undo"] = 143] = "Undo";
    IconSymbol[IconSymbol["Unknown"] = 144] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 145] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 146] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 147] = "Vinyl";
    IconSymbol[IconSymbol["Vocoder"] = 148] = "Vocoder";
    IconSymbol[IconSymbol["Volume"] = 149] = "Volume";
    IconSymbol[IconSymbol["VUMeter"] = 150] = "VUMeter";
    IconSymbol[IconSymbol["Waveform"] = 151] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 152] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
